import React from 'react';
import s from './Selector.scss';
import { Arrow } from '../Arrow/Arrow';
import CheckedIcon from './checked.svg';
import { useView, View } from '../../../../../providers/ViewProvider';
export const Selector = ({ options, selectedValue, onSelect, backButtonText, onBackButtonClick, visible, }) => {
    const { setView } = useView();
    const handleSelect = (value) => {
        onSelect(value);
        setView(View.Menu);
    };
    return (React.createElement("div", { style: {
            visibility: visible ? 'visible' : 'hidden',
        } },
        React.createElement("button", { className: s.backButton, onClick: onBackButtonClick },
            React.createElement(Arrow, { left: true }),
            React.createElement("h5", { className: s.title }, backButtonText)),
        React.createElement("ul", { className: s.list }, options.map(({ displayText, value }) => (React.createElement("li", { key: value },
            React.createElement("button", { className: s.optionButton, onClick: () => handleSelect(value) },
                selectedValue === value ? React.createElement(CheckedIcon, null) : null,
                React.createElement("span", { className: s.optionTitle }, displayText))))))));
};
//# sourceMappingURL=Selector.js.map